import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {
  Form,
  Row,
  Col,
  Space,
  DatePicker,
  Input,
  Button,
  Spin,
  message,
  Divider,
  Typography,
} from "antd";
import {pharmacyStoreService, catalogService, storeService} from "api";
import {InputFields} from "components/common";
import {columns as columnsInit, fieldsInit} from "./config";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import Notification from "components/common/notification/notification";
import {randomId} from "helper/common";

const ModalContent = forwardRef((props: any, ref) => {
  const {
    data,
    closeModal,
    type,
    getListMedicine,
    setListMedicine,
    listMedicine,
    nameCatalog,
  } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [fields, setFields] = useState(fieldsInit);
  const [dataTable, setDataTable] = useState<any[]>([]);
  const [columns, setColumns] = useState(columnsInit);
  useEffect(() => {
    getListUnit();
    getListBaoChe();
    getListDuocChinh();
    getListMedicineType();
    getListMedicineGroup();
    getListSubstance();
    getListDuongDung();
  }, []);
  useImperativeHandle(ref, () => ({
    resetFields: () => {
      form.setFieldValue("maLoaiThuocBHYT", 4);
      form.resetFields();
    },
  }));
  useEffect(() => {
    // getListUnit(1, 10);
    if (type == "Thêm") {
      form.resetFields();
    } else {
      const newData = {...data, isStend: data.isStend == true ? [true] : []};
      form.setFieldsValue(newData);

      setDataTable(data.unitConversionDto || []);
    }
  }, [data]);
  const getParams = () => {
    const params = {
      ...form.getFieldsValue(),
      isStend: form.getFieldValue("isStend")?.includes(true) ? true : false,
      unitConversionDto: dataTable,
    };
    return params;
  };
  const addMedicine = async () => {
    await form.validateFields();
    try {
      setLoading(true);
      const params = getParams();
      await pharmacyStoreService.addMedicine(params);
      setLoading(false);
      closeModal();

      await getListMedicine();
    } catch (error) {
      setLoading(false);
      if (error?.response?.data.includes("sử dụng")) {
        Notification("error", error?.response?.data);
      } else {
        Notification(
          "error",
          error?.response?.data ?? `Đã có lỗi khi thêm ${nameCatalog}`
        );
      }
    }
  };
  const editMedicine = async () => {
    setLoading(true);

    try {
      const params = getParams();

      await pharmacyStoreService.editMedicine(params);
      setLoading(false);
      closeModal();
      // const indexOfRecord = listMedicine.findIndex(e => e.id == data.id);
      // let newListMedicine=listMedicine;

      await getListMedicine();
    } catch (error) {
      setLoading(false);
      if (error?.response?.data.includes("sử dụng")) {
        Notification("error", error?.response?.data);
      } else {
        Notification(
          "error",
          error?.response?.data ?? `Đã có lỗi khi sửa thông tin ${nameCatalog}`
        );
      }
    }
  };
  const getListMedicineType = async () => {
    try {
      const res = await pharmacyStoreService.getListMedicineType(1, 50);
      fieldsInit.find(e => e.name == "loaiThuocId").options = res.data.map(
        e => ({key: randomId(), value: e.id, label: e.name})
      );
      setFields([...fieldsInit]);
    } catch (error) {
      Notification("error", `Đã có lỗi khi lấy danh sách loại thuốc`);
    }
  };
  const getListBaoChe = async () => {
    try {
      const res = await catalogService.getListBaoChe();
      fieldsInit.find(e => e.name == "baoCheId").options = res.map(e => ({
        value: e.id,
        label: e.name,
      }));
      setFields([...fieldsInit]);
    } catch (error) {}
  };
  const getListDuocChinh = async () => {
    try {
      const res = await catalogService.getListDuocChinh();
      fieldsInit.find(e => e.name == "duocChinhId").options = res.map(e => ({
        value: e.id,
        label: e.name,
      }));
      setFields([...fieldsInit]);
    } catch (error) {}
  };
  const getListDuongDung = async () => {
    try {
      const res = await catalogService.getListDuongDung();
      fieldsInit.find(e => e.name == "duongDungId").options = res?.data?.map(
        e => ({
          value: e.id,
          label: e.name,
        })
      );
      setFields([...fieldsInit]);
    } catch (error) {}
  };
  const getListUnit = async () => {
    try {
      const res = await catalogService.getListUnit();
      columnsInit.find(e => e.dataIndex == "donViChuyenDoi").options =
        res.data.map(e => ({value: e.id, label: e.name}));
      fieldsInit.find(e => e.name == "donViTinhId").options = res.data.map(
        e => ({key: randomId(), value: e.id, label: e.name})
      );
      setColumns([...columnsInit]);
      setFields([...fieldsInit]);
    } catch (error) {
      Notification("error", `Đã có lỗi khi lấy danh sách đơn vị chuyển đổi`);
    }
  };

  const getListMedicineGroup = async () => {
    try {
      const res = await pharmacyStoreService.getListMedicineGroup(1, 100);
      fieldsInit.find(e => e.name == "nhomThuocId").options = res.data.map(
        e => ({key: randomId(), value: e.id, label: e.name})
      );
      setFields([...fieldsInit]);
    } catch (error) {
      Notification("error", `Đã có lỗi khi lấy danh sách nhóm thuốc`);
    }
  };
  const getListSubstance = async () => {
    try {
      const res = await pharmacyStoreService.getListSubstance(1, 200);
      fieldsInit.find(e => e.name == "hoatChatId").options = res.data.map(
        e => ({value: e.id, label: e.name})
      );
      setFields([...fieldsInit]);
    } catch (error) {
      Notification("error", `Đã có lỗi khi lấy danh sách Hoạt chất`);
    }
  };
  const onFinish = values => {
    if (type == "Thêm") {
      addMedicine();
    } else {
      editMedicine();
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Typography.Text strong>Thông tin thuốc</Typography.Text>
        <Divider type="horizontal" style={{margin: 0, marginBottom: 8}} />
        <Form form={form} onFinish={onFinish} style={{marginBottom: 16}}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 16]}>
              {fields && <InputFields data={fields}></InputFields>}
            </Row>
          </Space>
        </Form>

        <Typography.Text strong>Chuyển đổi giữa các đơn vị</Typography.Text>
        <Divider type="horizontal" style={{margin: 0, marginBottom: 8}} />
        <TableInputAdd
          setDataTable={setDataTable}
          isCheckbox={undefined}
          isPagination={false}
          dataTable={dataTable}
          column={columns}
          disabled={undefined}
        ></TableInputAdd>
        <Row justify="end" style={{marginTop: 12}}>
          <Col>
            <Space>
              <Button onClick={closeModal}>Hủy</Button>
              <Button onClick={onFinish} type="primary">
                Xác nhận
              </Button>
            </Space>{" "}
          </Col>
        </Row>
      </Spin>
    </div>
  );
});
export default ModalContent;
